import { BreakpointState } from '@angular/cdk/layout';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LogEventService } from 'src/app/main/pazienti/service/log-event.service';
import { PazientiService } from 'src/app/main/pazienti/service/pazienti.service';
import { AppService } from 'src/app/service/app.service';
import { QuestionnaireService } from 'src/app/service/questionnaire-service.service';
import { UserService } from 'src/app/service/user-service.service';
import { endpoints } from 'src/endpoint/endpoints';

@Component({
  selector: 'app-scale-di-valutazione-mrs',
  templateUrl: './scale-di-valutazione-mrs.component.html',
  styleUrls: ['./scale-di-valutazione-mrs.component.scss']
})
export class ScaleDiValutazioneMRSComponent implements OnInit {

  // Per gestire il mobile
  isMobile = false;
  observer;

  clinicalImpressionId;
  idQuestionario;

  domande;

  isVisit = false;
  patientId;

  constructor(private toastr: ToastrService, private userService: UserService, private pazientiService: PazientiService,
    private http: HttpClient, private route: ActivatedRoute, private appServ: AppService, private questionariService: QuestionnaireService,
    private logService: LogEventService) { }

  ngOnInit() {
    this.getIsInVisite();
    this.getQuestionario();
    this.observer = this.appServ.mdAppObs
      .subscribe((statex: BreakpointState) => {
        this.isMobile = statex.matches;
      });
    this.patientId = this.pazientiService.getPatientId();
  }

  // Solo se non esiste nel database. Attenzione a non creare duplicati!!!
  creaQuestionario() {
    this.questionariService.createQuestionnaire(QuestionnaireService.MRS);
  }

  getIsInVisite() {
    const cId = this.route.parent.parent.snapshot.paramMap.get('vId');
    if (cId) {
      this.isVisit = true;
      this.clinicalImpressionId = cId;
    }
  }

  // Usare solo quando è realmente necessario
  aggiornaQuestionario() {
    this.questionariService.updateQuestionnaire(QuestionnaireService.MRS, this.idQuestionario);
  }

  getQuestionario() {
    const obj = {
      nome: 'MRS',
      versione: '1'
    };
    this.http.post(endpoints.getQuestionnaireByNameByVersion, obj).toPromise()
      .then((resp: any) => {
        this.idQuestionario = resp.id;
        this.domande = new Array();
        resp.item.forEach(item => {
          let domanda: any;
          domanda = {};
          domanda.testo = item.text;
          domanda.tipo = item.type;
          domanda.linkId = item.linkId;
          domanda.risposta = undefined;
          domanda.risposte = new Array();
          switch (domanda.tipo) {
            case 'boolean':
              domanda.risposte.push({
                value: 'true',
                label: 'Si'
              });
              domanda.risposte.push({
                value: 'false',
                label: 'No'
              });
              break;
            case 'integer':
              item.option.forEach(opt => {
                domanda.risposte.push({
                  label: opt.valueCoding.display,
                  value: opt.valueCoding.code
                });
              });
              break;
            case 'quantity':
              break;
          }
          this.domande.push(domanda);
        });
        this.getRisposte();
      });
  }

  getRisposte() {
    let endpointToCall;
    let obj: any;
    obj = {};
    if (this.isVisit) {
      obj = { clinicalImpressionId: this.clinicalImpressionId, questionnaireId: this.idQuestionario };
      endpointToCall = endpoints.getClinicalImpressionSurveyResponse;
    } else {
      obj = { patientId: this.patientId, questionnaireId: this.idQuestionario };
      endpointToCall = endpoints.getClinicalImpressionSurveyResponseNLAB;
    }
    this.http.post(endpointToCall, obj).toPromise()
      .then((resp: any) => {
        const risposte = resp.item;
        let indice = 0;
        (this.domande.filter(d => d.tipo !== 'display')).forEach(domanda => {
          switch (domanda.tipo) {
            case 'quantity':
              domanda.risposta = '' + risposte[indice++].answer[0].valueQuantity.value;
              break;
            case 'integer':
              domanda.risposta = '' + risposte[indice++].answer[0].valueInteger;
              break;
            case 'boolean':
              domanda.risposta = domanda.risposte.find(d => d.value === '' + risposte[indice].answer[0].valueBoolean);
              indice++;
              break;
          }
        });
        this.logService.getAllOpt([[resp]], null);
      }).catch(err => {
        if (err.status === 404) {
          this.toastr.info('Questionario non eseguito.');
          this.logService.resetGlobalVarLog();
        } else {
          console.error(err);
        if (err.status == 403) {
          this.toastr.error("Non si dispone dei permessi necessari per eseguire questa operazione.");
          return;
        }
          this.toastr.error('Errore nel caricamento delle risposte del questionario.');
        }
      });
  }

  salva() {

    const punteggio = this.domande.find(d => d.tipo === 'quantity');
    punteggio.risposta = 0;

    let endpointToCall;
    let obj: any;
    obj = {};
    if (this.isVisit) {
      obj = {
        answers: new Array(),
        questionnaireId: this.idQuestionario,
        clinicalImpressionId: this.clinicalImpressionId
      };
      endpointToCall = endpoints.addClinicalImpressionSurveyResponse;
    } else {
      obj = {
        answers: new Array(),
        questionnaireId: this.idQuestionario,
        patientId: this.patientId
      };
      endpointToCall = endpoints.addClinicalImpressionSurveyResponseNLABsub;
    }

    // Controllo se sono state risposte tutte le domande
    if (((this.domande.filter(d => d.tipo !== 'display')).filter(d => d.risposta === undefined)).length > 0) {
      this.toastr.warning('Non sono state risposte tutte le domande.');
      return;
    }
    try {
      let r;
      (this.domande.filter(d => d.tipo !== 'display')).forEach(domanda => {
        switch (domanda.tipo) {
          case 'quantity':
            if (domanda.testo.includes('Totale')) {
              r = domanda.risposta;
            }
            break;
          case 'integer':
              r = domanda.risposta;
              punteggio.risposta += Number(r);
              break;
        }

        obj.answers.push({
          linkId: domanda.linkId,
          answer: r + '',
          type: domanda.tipo
        });
      });
    } catch (Exception) {
      this.toastr.error(Exception.message);
      return;
    }

    this.http.post(endpointToCall, obj).toPromise()
      .then((resp: any) => {
        this.toastr.success('Salvataggio avvenuto con successo.');
        this.getQuestionario();
      }).catch(err => {
        console.error(err);
        if (err.status == 403) {
          this.toastr.error("Non si dispone dei permessi necessari per eseguire questa operazione.");
          return;
        }
        this.toastr.error('Errore nel salvataggio delle risposte del questionario.');
      });
  }

  checkPermessoModifica() {
    if (this.isVisit) {
      return this.userService.checkPermission('Osservazioni', 'modify') && this.userService.checkPermission('Visite', 'modify');
    } else {
      return this.userService.checkPermission('Anagrafica pazienti', 'modify')
    }
  }

}
